import React, { useState } from 'react';
import { connect } from 'react-redux';
import { Modal } from 'reactstrap';
import EmployeeEditDialogBody from './EmployeeEditDialogBody';
import EmployeeEditDialogHeader from './EmployeeEditDialogHeader';

const EmployeeEditDialog = ({ show, onHide, id, isEdit, rtl, slug }) => {
  const [modal] = useState({
    isOpen: show,
    title: `${isEdit ? 'Edit' : 'Add'} Employee`,
    hide: onHide,
  });

  return (
    <Modal
      isOpen={show}
      toggle={modal.hide}
      backdrop={'static'}
      modalClassName={`${rtl.direction}-support`}
      className="modal-dialog--primary modal-dialog--header modal-edit-dialog"
    >
      <EmployeeEditDialogHeader modal={modal} />
      <EmployeeEditDialogBody modal={modal} isEdit={isEdit} id={id} slug={slug} />
    </Modal>
  );
};

export default connect((state) => ({
  rtl: state.rtl,
}))(EmployeeEditDialog);
